module.exports = require("resolve");